import {
  APP_PUBLICATIONS_REQUEST,
  APP_PUBLICATIONS_RESPONSE,
  APP_PUBLICATIONS_FAILURE,
  UPDATE_APP_PUBLICATIONS_FILTER_STATE,
} from "../../../actions/types";

const initialState = {
  error: false,
  isFetching: false,
  totalPublications: 0,
  totalStakeholders: 0,
  results: [],
  filters: {
    from: 0,
    size: 25,
    activePage: 1,
    queryText: "",
    brief_title: "",
    terms: [],
    TOPICS: [],
    conditions: "",
    interventions: "",
    sponsors: "",
    recruiters: "",
    publication_type: "",
    highlight: "",
    ArticleTitle: "",
    EXPERTS: "",
    JournalTitle: "",
    sorting: { key: "PmcCitation", order: "desc" },
  },
};

const setFetching = (state, action) => {
  let {
    from = 0,
    size = 25,
    activePage = 1,
    queryText = "",
    brief_title = "",
    terms = [],
    TOPICS = [],
    conditions = "",
    interventions = "",
    sponsors = "",
    recruiters = "",
    publication_date,
    publication_type,
    highlight,
    ArticleTitle,
    EXPERTS,
    JournalTitle,
    sorting
  } = action.payload;

  return {
    ...state,
    isFetching: true,
    results: [],
    totalPublications: 0,
    totalStakeholders: 0,
    filters: {
      ...state?.filters,
      from,
      size,
      activePage,
      queryText,
      brief_title,
      terms,
      TOPICS,
      conditions,
      interventions,
      sponsors,
      recruiters,
      publication_date,
      publication_type,
      highlight,
      ArticleTitle,
      EXPERTS,
      JournalTitle,
      sorting
    },
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: [],
    totalPublications: 0,
    totalEnrollments: 0,
    totalInvestigators: 0,
    totalStakeholders: 0,
  };
};

const setResults = (state, action) => {
  let results = action.payload.results || [];
  let totalPublications = action.payload.total || 0;
  let totalStakeholders = action.payload.totalStakeholders || 0;

  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    totalPublications,
    totalStakeholders,
  };
};

const updateFilterState = (state, action) => {
  let { filters = {} } = action.payload;
  let {
    from = 0,
    size = 25,
    activePage,
    brief_title,
    terms = [],
    TOPICS = [],
    conditions,
    interventions,
    sponsors,
    queryText = "",
    recruiters,
    publication_type,
    highlight,
    ArticleTitle,
    EXPERTS,
    JournalTitle,
    sorting
  } = filters || {};

  return {
    ...state,
    filters: {
      ...state?.filters,
      from,
      size,
      activePage,
      brief_title,
      terms,
      TOPICS,
      conditions,
      interventions,
      sponsors,
      queryText,
      recruiters,
      publication_type,
      highlight,
      ArticleTitle,
      EXPERTS,
      JournalTitle,
      sorting
    },
  };
};

const ClinicalTrialReducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_PUBLICATIONS_REQUEST:
      return setFetching(state, action);

    case APP_PUBLICATIONS_RESPONSE:
      return setResults(state, action);

    case APP_PUBLICATIONS_FAILURE:
      return setFailure(state, action);

    case UPDATE_APP_PUBLICATIONS_FILTER_STATE:
      return updateFilterState(state, action);

    default:
      return state;
  }
};

export default ClinicalTrialReducer;
